var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loaded)?_c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"wrap"},[_vm._t("default"),_c('div',{staticClass:"copyright"},[_vm._v("© 2024 Mitsui Fudosan Co., Ltd. All Rights Reserved.")])],2),_c('a',{staticClass:"pageTop off",attrs:{"href":"#wrap"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }